import { Typography, TextField, IconButton, Box, Button } from "@mui/material";
import { Stack } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { useEffect, useState } from "react";
import { ShotgunTeeSheet } from "./ShotgunTeeSheet";
import { TraditionalTeeSheet } from "./TraditionalTeeSheet";
import { ReservesList } from "./ReservesList";
import { MatchPlayTeeSheet } from "./MatchPlayTeeSheet";
import { useTBContext } from "../Contexts/useTBStates";
import { useAuth } from "react-oidc-context";
import CreateApi from "../../shared/Settings/appSettings";

interface EventTeeSheetProps {
    tabHeight?: number;
    tabWidth?: number;
    roundLocked?: boolean;
}

export const EventTeeSheet = ({ 
    tabHeight,
    tabWidth,
    roundLocked = false,
}: EventTeeSheetProps) => {

    const api = CreateApi();
    const auth = useAuth();

    const {
        viewEvent,
        viewEventData, 
        roundValue, 
        factor, appTheme, 
      } = useTBContext();

    console.log('viewEvent', viewEvent);
    if (!viewEvent) return null;

    const currentRound = viewEvent.rounds[roundValue-1];

    const createTeeTime = (startingTime: any, rowIndex: number) => {
        const [timePart] = startingTime.split('.'); // Get the part before the decimal
        const [hours, minutes, seconds] = timePart.split(':');
        // Use the round's own roundDate if set; fall back to startDate + (roundValue-1) days
        const baseDate = currentRound.roundDate
            ? new Date(currentRound.roundDate)
            : (() => {
                const d = new Date(viewEvent.startDate);
                d.setUTCDate(d.getUTCDate() + (roundValue - 1));
                return d;
            })();
        // Use UTC arithmetic throughout so the resulting ISO string matches the stored tee times,
        // which are stored with the starting-time hour treated as UTC (e.g. "08:10" → ...T08:10:00.000Z).
        const baseMs = Date.UTC(
            baseDate.getUTCFullYear(),
            baseDate.getUTCMonth(),
            baseDate.getUTCDate(),
            parseInt(hours),
            parseInt(minutes),
            parseInt(seconds) || 0
        );
        return new Date(baseMs + rowIndex * currentRound.teeTimeGap * 60000);
    }

    return (
        <Stack direction='row' spacing={1}
            sx={{
                width: tabWidth ?? '100%',
                height: tabHeight ?? '100%',
                minHeight: 0,
                flex: 1,
                boxSizing: 'border-box',
            }}
        >
            <Stack direction='column' spacing={0.25} paddingTop={1} width={'15%'}
                sx={{ overflow: 'hidden', height: '100%', minHeight: 0 }}>
                <ReservesList tabHeight={tabHeight} />
            </Stack>
            <Stack direction='column' spacing={1} width={'85%'} paddingTop={1}
                sx={{
                    height: '100%',
                    minHeight: 0,
                    overflow: 'hidden',
                    border: `1px solid ${appTheme.palette.primary.extraLight}`,
                    borderRadius: 1,
                }}
            >
                {(/* currentRound.playerVersus.toLowerCase() === 'field' || */ !currentRound.useBracket) && (
                <>
                    <Stack direction='row' spacing={2} sx={{ borderBottom: '1px solid lightgray', paddingBottom: 1, height: 20*factor, alignItems: 'center', flexShrink: 0 }}>
                        <Typography sx={{ flex: 1, fontWeight: 500, textAlign: 'center', fontSize: 14*factor }}>
                            {currentRound.shotgunStart ? 'Start Hole' : 'Tee Time'}
                        </Typography>
                        {Array.from({ length: currentRound.regPerTeeTime }).map((_, index) => (
                            <Typography key={`player-${index}`} sx={{ flex: 2, fontWeight: 500, textAlign: 'center', fontSize: 14*factor }}>Player {index + 1}</Typography>
                        ))}
                    </Stack>
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', height: tabHeight != null ? tabHeight - 40*factor : undefined }}>
                        {currentRound.shotgunStart ? (
                            <ShotgunTeeSheet
                                createTeeTime={createTeeTime}
                                roundLocked={roundLocked}
                            />
                        ) : (
                            <TraditionalTeeSheet 
                                createTeeTime={createTeeTime}
                                roundLocked={roundLocked}
                            />
                        )}
                    </Box>
                </>)}

                {/* currentRound.playerVersus.toLowerCase() === 'player' && */ currentRound.useBracket && (
                <MatchPlayTeeSheet
                        createTeeTime={createTeeTime}
                        roundLocked={roundLocked}
                    />
                )}
            </Stack>
        </Stack>
    )
}
